import React, { ReactElement } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import i18next from 'i18next';
import AdminEnduranceTrainingTypes from '../components/AdminEnduranceTrainingTypes';
import AdminExerciseCategories from '../components/AdminExerciseCategories';
import Therapists from '../components/Therapists';
import Patients from '../components/Patients';
import TelerehabilitationPrograms from '../components/TelerehabilitationPrograms';
import AdminExerciseTags from '../components/AdminExerciseTags';
import AdminExercises from '../components/AdminExercises';

const AdminPage = (): ReactElement => {
  return (
    <div className="w-100 mx-auto bg-white p-4" style={{ maxWidth: '90vw' }}>
      <Tabs defaultActiveKey="therapists" id="admin-sections" mountOnEnter={true}>
        <Tab eventKey="therapists" title={i18next.t('adminPage.therapists')}>
          <Therapists />
        </Tab>
        <Tab eventKey="patients" title={i18next.t('adminPage.patients')}>
          <Patients />
        </Tab>
        <Tab eventKey="telerehaPrograms" title={i18next.t('adminPage.telerehaPrograms')}>
          <TelerehabilitationPrograms />
        </Tab>
        <Tab eventKey="exercises" title={i18next.t('adminPage.exercises')}>
          <AdminExercises />
        </Tab>
        <Tab eventKey="exericeTags" title={i18next.t('adminPage.exerciseTags')}>
          <AdminExerciseTags />
        </Tab>
        <Tab eventKey="exercieCategories" title={i18next.t('adminPage.exerciseCategories')}>
          <AdminExerciseCategories />
        </Tab>
        <Tab eventKey="enduranceTrainingTypes" title={i18next.t('adminPage.enduranceTrainingTypes')}>
          <AdminEnduranceTrainingTypes />
        </Tab>
      </Tabs>
    </div>
  );
};

export default AdminPage;
